import React, { useEffect, useState, useRef } from "react";
import { Tabs, Tab } from "@mui/material";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import apiService from "../../services/apiservice";
import { toast } from "react-toastify";
import { InputTextarea } from "primereact/inputtextarea";
import { FaEye, FaUpload } from "react-icons/fa";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';
import moment from 'moment';

const SERVICE_TYPE_DS = [
  { id: 8, value: "IPD" },
  { id: 9, value: "OPD" },
  { id: 10, value: "Investigation" },
  { id: 11, value: "Day Care " },
  { id: 12, value: 'Physiotherapy' },

];

const HOSPITALIZATION_TYPES = {
  IPD: [
    { value: 1, name: "General Surgery" },
    { value: 2, name: "Oncology" },
    { value: 3, name: "Neurology" },
    { value: 4, name: "Orthopedic" },
    { value: 5, name: "Urology" },
    { value: 6, name: "Cardiology" },
    { value: 7, name: "ENT" },
    { value: 8, name: "Gynecology" },
    { value: 10, name: "Opthalmology" },
    { value: 11, name: "General Medicine" },
    { value: 15, name: "Nephrology" },
  ],
  OPD: [{ value: 12, name: "OPD Others" }],
  INVESTIGATION: [{ value: 13, name: "Investigation Others" }],
  DAYCARE: [{ value: 14, name: "Day Care Others" }],
  PHYSIO: [{ value: 16, name: "Physiotherapy" }]

};

const SUB_SERVICE_LIST = [
  { value: 1, name: "Emergency" },
  { value: 2, name: "Non-Emergency" },
  { value: 3, name: "Others" },
];

const CONCIERGE_STATUS_LIST = [
  { id: 1, value: "Patient Admitted" },
  { id: 2, value: "Patient Denied" },
  { id: 3, value: "Patient iN OT" },
  { id: 4, value: "Patient Discharged" },
  { id: 5, value: "Hospital Denied" },
  { id: 6, value: "Patient is on the Way" },
  { id: 7, value: "Admission in Process" },
  { id: 8, value: "Patient in ICU" },
  { id: 9, value: "Patient in HDU" },
  { id: 10, value: "OT is scheduled Today" },
  { id: 11, value: "OT Cancelled" },
  { id: 12, value: "OT is Completed Today" },
  { id: 13, value: "Patient in Ward" },
  { id: 14, value: "Only OPD Done" },
  { id: 15, value: "Discharge is scheduled Today" }
];

const STATUS_DS = [
  { id: 0, value: "Rejected" },
  { id: 1, value: "Under Process" },
  { id: 4, value: "Patient Denied" },
  { id: 5, value: "Hospital Denied" },
  { id: 6, value: "Procedure Confirmed" },
  { id: 7, value: "Hold" },
  { id: 12, value: "Waiting For Approval" },
];

const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  let month = "" + (d.getMonth() + 1);
  let day = "" + d.getDate();
  const year = d.getFullYear();
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  return [month, day, year].join("/");
};

const parseDate = (dateString) => {
  if (!dateString) return null;
  if (dateString instanceof Date) return dateString;
  if (typeof dateString === 'string' && dateString.includes('/')) {
    const [month, day, year] = dateString.split("/");
    return new Date(year, month - 1, day);
  }
  return new Date(dateString);
};

const convertUTCToLocal = (date) => {
  if (!date) return "";
  const localTime = moment.utc(date).toDate();
  return moment(localTime).format("YYYY-MM-DD");
};

const getTraumaLabel = (status) => {
  switch (status) {
    case 0: return { main: "No", sub: "" };
    case 1: return { main: "Yes", sub: "Waiting for Approval" };
    case 2: return { main: "Yes", sub: "Approved" };
    case 3: return { main: "Yes", sub: "Rejected" };
    default: return { main: "", sub: "" };
  }
};

const getTraumaColor = (status) => {
  switch (status) {
    case 1: return "orange";
    case 2: return "green";
    case 3: return "red";
    default: return "black";
  }
};

const encodeBase64File = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const baseURL = reader.result;
      resolve(baseURL.split(',')[1]);
    };
  });
};

const renderTraumaStatus = (selected) => {
  if (selected?.traumaStatus === undefined) return null;
  const trauma = getTraumaLabel(selected.traumaStatus);
  return (
    <div className="col-span-3">
      <span className="text-[#004172] font-bold">Trauma :</span>
      <span className="ml-2">
        <div>
          <div>
            <span style={{ color: "black" }}>
              {trauma.main}
              {trauma.sub && (
                <>
                  {" ("}
                  <span style={{ color: getTraumaColor(selected.traumaStatus) }}>
                    {trauma.sub}
                  </span>
                  {")"}
                </>
              )}
            </span>
          </div>
          {selected?.traumaReason && (
            <div
              style={{
                fontSize: "0.875rem",
                color: "#666",
                marginTop: "2px",
              }}
            >
              Reason: {selected.traumaReason}
            </div>
          )}
        </div>
      </span>
    </div>
  );
};

const validateTab1 = (selectedRow) => {
  if (!selectedRow.preferredHospitalAndClinics) {
    toast.error("Please Select Hospital and Clinics");
    return false;
  }
  return true;
};

const validateTab2 = (selectedRow) => {
  if (!selectedRow.serviceType) {
    toast.error("Please select Service Type");
    return false;
  }
  if (!selectedRow.procedurePlannedStartDate) {
    toast.error("Please Select Planned Start Date");
    return false;
  }
  if (!selectedRow.procedurePlannedEndDate) {
    toast.error("Please Select Planned End Date");
    return false;
  }
  if (!selectedRow.procedurePlannedDate &&
    ![4, 5, 0, 7].includes(selectedRow.status)) {
    toast.error("Please Select Procedure Confirmed Date");
    return false;
  }
  if (selectedRow.status === 7 && !selectedRow.reasonForHold) {
    toast.error("Please Enter Reason for Hold");
    return false;
  }
  if (selectedRow.status === 0 && !selectedRow.reasonForReject) {
    toast.error("Please Enter Reason for Reject");
    return false;
  }
  return true;
};

const validateCurrentTab = (activeIndex, selectedRow) => {
  if (activeIndex === 0) {
    return validateTab1(selectedRow);
  }
  if (activeIndex === 1) {
    return validateTab2(selectedRow);
  }
  return true;
};

const DocumentItem = ({ label, fileName, onView }) => (
  <div className="flex items-center justify-between sm:justify-start sm:gap-3 p-3 bg-gray-50 rounded-lg">
    <span className="font-medium text-gray-700 text-sm sm:text-base whitespace-nowrap">
      {label}
    </span>
    <button
      onClick={onView}
      className="flex-shrink-0 hover:opacity-80 transition-opacity"
      disabled={!fileName}
      type="button"
    >
      <FaEye className={`text-lg ${fileName ? "text-[#6fb8ef]" : "text-gray-400"}`} />
    </button>
  </div>
);

DocumentItem.propTypes = {
  label: PropTypes.string.isRequired,
  fileName: PropTypes.string,
  onView: PropTypes.func.isRequired,
};

const AddEnquiry = ({ selected, onClose }) => {
  const userObj = JSON.parse(localStorage.getItem("loginObj") || '{}');
  const roleCode = localStorage.getItem("userRole") || '';
  const [loading, setLoading] = useState(false);
  const initialConciergeUserCode = useRef(null);
  const [selectedRow, setSelectedRow] = useState(selected || {});
  const [activeIndex, setActiveIndex] = useState(0);
  const [hospitalList, setHospitalList] = useState([]);
  const [ceUserList, setCeUserList] = useState([]);
  const [procedureList, setProcedureList] = useState([]);
  const [consentBlob, setConsentBlob] = useState();
  const [dischargeBlob, setDischargeBlob] = useState();
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
  const [feedbackData, setFeedbackData] = useState({
    patientName: '',
    patientMobile: ''
  });
  const [originalMobile, setOriginalMobile] = useState('');
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);

  const isFormDisabled = selectedRow.billingStatus === 2 ||
    selectedRow.status === 11 ||
    roleCode === "ACCADMIN";

  useEffect(() => {
    const fetchData = async () => {
      await getFormData();
      await getHospitalList();
      await getConciergeList();
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchHospitalizationList = async () => {
      if (selectedRow.serviceType && selectedRow.hospitalizationTypeId) {
        await getHospitaliztionList(selectedRow.hospitalizationTypeId);
      }
    };
    fetchHospitalizationList();
  }, [selectedRow.serviceType, selectedRow.hospitalizationTypeId]);

  const getFormData = async () => {
    try {
      const payload = { enquiryId: selected.id };
      const result = await apiService.getEnquiryById(payload);
      const result1 = result.data.successObject;

      result1.procedurePlannedEndDate = formatDate(result1.procedurePlannedEndDate);
      result1.procedurePlannedStartDate = formatDate(result1.procedurePlannedStartDate);
      result1.procedurePlannedDate = formatDate(
        result1?.procedurePlannedDate ? result1?.procedurePlannedDate : new Date()
      );

      initialConciergeUserCode.current = result1.conciergeUserCode;
      setSelectedRow(result1);

      if (result1.serviceType && result1.hospitalizationTypeId) {
        await getHospitaliztionList(result1.hospitalizationTypeId);
      }
    } catch (error) {
      console.error('Error fetching form data:', error);
      toast.error('Failed to load form data');
    }
  };

  const getHospitalList = async () => {
    try {
      const payload = { status: 1, HospitalType: "H" };
      const res = await apiService.getHospitalList(payload);
      const hospitals = res.data.successObject.map(element => ({
        ...element,
        hospitalLocationNames: `${element.hospitalName} (${element.name})`
      }));
      setHospitalList(hospitals);
    } catch (error) {
      console.error('Error fetching hospital list:', error);
      toast.error('Failed to load hospitals');
    }
  };

  const getHospitaliztionList = async (hospitalizationTypeId) => {
    try {
      if (!selectedRow.serviceType || !hospitalizationTypeId) {
        setProcedureList([]);
        return;
      }
      const payload = {
        serviceType: selectedRow.serviceType,
        hospitalizationTypeId: hospitalizationTypeId
      };
      const res = await apiService.getHospitaliztionList(payload);
      if (res?.data?.data?.length) {
        setProcedureList(res.data.data);
      } else {
        setProcedureList([]);
      }
    } catch (error) {
      console.error('Error fetching hospitalization list:', error);
      toast.error('Failed to load hospitalization subtypes');
      setProcedureList([]);
    }
  };

  const getConciergeList = async () => {
    try {
      const payload = { roleCode: "CE", status: 1 };
      const res = await apiService.getUserList(payload);
      if (res.data.successList.length > 0) {
        setCeUserList(res.data.successList);
      }
    } catch (error) {
      console.error('Error fetching concierge list:', error);
      toast.error('Failed to load concierge executives');
    }
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;

    if (name === "date") {
      setSelectedRow(prev => ({ ...prev, [e.target.name]: formatDate(value) }));
    } else {
      const updatedRow = { ...selectedRow, [name]: value };
      setSelectedRow(updatedRow);

      if (name === "hospitalizationTypeId") {
        if (value && updatedRow.serviceType) {
          await getHospitaliztionList(value);
        } else {
          setProcedureList([]);
        }
      }

      if (name === "serviceType" && updatedRow.hospitalizationTypeId) {
        await getHospitaliztionList(updatedRow.hospitalizationTypeId);
      }

      if ((name === "serviceType" || name === "hospitalizationTypeId") && updatedRow.procedureId) {
        updatedRow.procedureId = '';
        setSelectedRow(prev => ({ ...prev, procedureId: '' }));
      }
    }
  };

  const handleTabChange = (event, newValue) => {
    setActiveIndex(newValue);
  };

  const prepareTab0Payload = () => ({
    id: selectedRow.id,
    userCode: userObj.user?.code,
    insuranceId: selectedRow?.insuranceId || "",
    insuranceName: selectedRow?.insuranceName,
    insuranceAmount: selectedRow.insuranceAmount,
    preferredHospitalAndClinics: selectedRow.preferredHospitalAndClinics,
  });

  const prepareTab1Payload = () => {
    const payload = {
      id: selectedRow.id,
      userCode: userObj.user?.code,
      procedurePlannedStartDate: convertUTCToLocal(
        new Date(selectedRow.procedurePlannedStartDate)
      ),
      procedurePlannedEndDate: convertUTCToLocal(
        new Date(selectedRow.procedurePlannedEndDate)
      ),
      procedurePlannedDate: selectedRow.procedurePlannedDate ?
        convertUTCToLocal(new Date(selectedRow.procedurePlannedDate)) : null,
      status: selectedRow.status,
      estimateAmountForProcedure: selectedRow.estimateAmountForProcedure || 0,
      hasOtherMedicalConditions: selectedRow.hasOtherMedicalConditions,
      reasonForHold: selectedRow.reasonForHold,
      reasonForReject: selectedRow.reasonForReject,
      serviceSubTypeId: selectedRow.serviceSubTypeId,
      serviceType: selectedRow.serviceType,
      hospitalizationTypeId: selectedRow.hospitalizationTypeId,
      procedureId: selectedRow.procedureId,
      procedureNameDescription: selectedRow.procedureNameDescription,
    };
    return payload;
  };

  const prepareTab2Payload = () => {
    const payload = {
      id: selectedRow.id,
      userCode: userObj.user?.code,
      conciergeUserCode: selectedRow.conciergeUserCode || '',
      conciergeStatus: selectedRow.conciergeStatus || -1,
      conciergeName: ceUserList.find(ce => ce.code === selectedRow.conciergeUserCode)?.userName || ''
    };

    const currentConciergeCode = selectedRow.conciergeUserCode;
    const initialCode = initialConciergeUserCode.current;

    if (currentConciergeCode) {
      if (!initialCode) {
        payload.type = "ASSIGN";
      } else if (initialCode !== currentConciergeCode) {
        payload.type = "RE-ASSIGN";
      }
    }
    return payload;
  };

  const preparePayloadForTab = () => {
    const basePayload = {
      id: selectedRow.id,
      userCode: userObj.user?.code,
    };
    switch (activeIndex) {
      case 0:
        return prepareTab0Payload();
      case 1:
        return prepareTab1Payload();
      case 2:
        return prepareTab2Payload();
      default:
        return basePayload;
    }
  };

  const executeApiCall = async (payload) => {
    switch (activeIndex) {
      case 0:
        return await apiService.updateInsurence(payload);
      case 1:
        return await apiService.updateSevice(payload);
      case 2:
        return await apiService.updateConceirge(payload);
      default:
        throw new Error('Invalid tab index');
    }
  };

  const updateEnqList = async () => {
    if (!validateCurrentTab(activeIndex, selectedRow)) {
      return;
    }
    try {
      const payload = preparePayloadForTab();
      const result = await executeApiCall(payload);

      if (result.data.responseCode === "200") {
        toast.success(result.data.responseMessage);
        if (activeIndex < 2) {
          setActiveIndex(activeIndex + 1);
        }
        if (selectedRow.conciergeStatus !== 4 && selectedRow.conciergeStatus === 4) {
          onClose();
        }
      }
    } catch (error) {
      console.error('Error updating enquiry:', error);
      toast.error('Failed to update enquiry');
    }
  };

  const uploadBill = async (e, type) => {
    try {
      let b64File = await encodeBase64File(e.target.files[0]);
      let payload = {
        documentType: e.target.files[0].type.split("/")[1],
        documentByte: b64File,
        id: selectedRow.id,
      };

      if (type === "C") {
        setConsentBlob(URL.createObjectURL(e.target.files[0]));
        setLoading(true);
        await apiService.updateConsent(payload);
        setLoading(false);
      } else {
        setDischargeBlob(URL.createObjectURL(e.target.files[0]));
        setLoading(true);
        await apiService.updateDischarge(payload);
        setLoading(false);
      }
      e.target.value = null;
    } catch (error) {
      console.error('Error uploading bill:', error);
      setLoading(false);
      toast.error('Failed to upload file');
    }
  };

  const openUrl = async (fileName) => {
    try {
      const res = await apiService.openFilesBucket(fileName);
      if (res.data.responseCode === '200') {
        window.open(res.data.successObject, "_blank");
      }
    } catch (error) {
      console.error('Error opening URL:', error);
      toast.error('Failed to open file');
    }
  };

  const openFeeback = async () => {
    try {
      setLoading(true);
      const payload = selectedRow.id;
      const response = await apiService.getPatientFeedbackInfo(payload);

      if (response.data.responseCode === '200') {
        const data = response.data.successObject;
        setFeedbackData({
          patientName: data.firstName + ' ' + data.lastName,
          patientMobile: data.mobile
        });
        setOriginalMobile(data.mobile);
        setShowFeedbackPopup(true);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching feedback info:', error);
      setLoading(false);
      toast.error('Failed to fetch patient information');
    }
  };

  const handleFeedbackInputChange = (e) => {
    const { name, value } = e.target;
    setFeedbackData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleGetFeedback = () => {
    if (feedbackData.patientMobile === originalMobile) {
      submitFeedback();
    } else {
      setShowConfirmPopup(true);
    }
  };

  const submitFeedback = async () => {
    try {
      setLoading(true);
      const payload = { mobile: feedbackData.patientMobile };
      const response = await apiService.getFeedback(payload, selected.id);

      if (response.data.responseCode === '200') {
        toast.success('Feedback request sent successfully');
        setShowFeedbackPopup(false);
        setShowConfirmPopup(false);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error submitting feedback:', error);
      setLoading(false);
      toast.error('Failed to submit feedback request');
    }
  };

  const handleConfirmUpdate = async () => {
    try {
      setLoading(true);
      const updatePayload = {
        code: selectedRow.patientId,
        mobile: feedbackData.patientMobile,
        modifiedBy: userObj.user.code,
      };

      const updateResponse = await apiService.patientSave(updatePayload);

      if (updateResponse.data.responseCode === '200') {
        await submitFeedback();
      }
    } catch (error) {
      console.error('Error updating patient mobile:', error);
      setLoading(false);
      toast.error('Failed to update patient mobile number');
    }
  };

  const getApproval = async () => {
    if (!selectedRow.preferredHospitalAndClinics) {
      return toast.error("Please Select Hospital and Clinics");
    } else if (!selectedRow.serviceType) {
      return toast.error("Please select Service Type");
    } else if (!selectedRow.procedurePlannedStartDate) {
      return toast.error("Please Select  Planned Start Date");
    } else if (!selectedRow.procedurePlannedEndDate) {
      return toast.error("Please Select  Planned End Date");
    } else if (
      (!selectedRow.procedurePlannedDate ||
        selectedRow.procedurePlannedDate === "NaN/NaN/NaN" ||
        selectedRow?.procedurePlannedDate === "Invalid date") &&
      selectedRow.status !== 4 &&
      selectedRow.status !== 5 &&
      selectedRow.status !== 0 &&
      selectedRow.status !== 7
    ) {
      return toast.error("Please Select Procedure Confirmed Date");
    } else if (selectedRow.status === 7 && !selectedRow.reasonForHold) {
      return toast.error("Please Enter Reason for Hold");
    } else if (selectedRow.status === 0 && !selectedRow.reasonForReject) {
      return toast.error("Please Enter Reason for Reject");
    }
    await updateEnqList();
    if (
      !selectedRow?.procedurePlannedDate ||
      selectedRow?.procedurePlannedDate === "Invalid date" ||
      selectedRow?.procedurePlannedDate === "NaN/NaN/NaN"
    ) {
      return;
    }
    try {
      let payload = {
        publishStatus: "W",
        modifiedBy: userObj.user.code,
        procedurePlannedDate: convertUTCToLocal(
          new Date(selectedRow.procedurePlannedDate)
        ),
      };
      const res = await apiService.getApproval(payload, selectedRow.id);
      if (res.data.responseCode === "200") {
        toast.success("Request sent Successfully");
        handleCancel();
      }
    } catch (error) {
      console.error("Error fetching enquiry list:", error);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  const getHospitalizationOptions = () => {
    const serviceType = Number.parseInt(selectedRow?.serviceType, 10);
    if (serviceType === 8) return HOSPITALIZATION_TYPES.IPD;
    if (serviceType === 9) return HOSPITALIZATION_TYPES.OPD;
    if (serviceType === 10) return HOSPITALIZATION_TYPES.INVESTIGATION;
    if (serviceType === 11) return HOSPITALIZATION_TYPES.DAYCARE;
    if (serviceType === 12) return HOSPITALIZATION_TYPES.PHYSIO;

    return [];
  };

  const personalDetails = [
    {
      label: "Name",
      value: `${selectedRow?.patientDetails?.salutation || ''} ${selectedRow?.patientDetails?.firstName || ''} ${selectedRow?.patientDetails?.lastName || ''}`.trim(),
    },
    { label: "DOB", value: formatDate(selectedRow?.patientDetails?.dob) },
    { label: "Email Id", value: selectedRow?.patientDetails?.email },
    { label: "Mobile Number", value: selectedRow?.patientDetails?.mobile },
    { label: "Address 1", value: selectedRow?.addressDetails?.address1 },
    { label: "Address 2", value: selectedRow?.addressDetails?.address2 },
    { label: "City", value: selectedRow?.addressDetails?.city },
    { label: "State", value: selectedRow?.addressDetails?.stateName },
  ];

  const hospitalizationOptions = getHospitalizationOptions();

  const renderPersonalDetailItem = (item) => (
    <div key={`detail-${item.label}`} className="flex items-center gap-x-2 mt-2">
      <span className="font-semibold">{item.label}:</span>
      <span>{item.value || "-"}</span>
    </div>
  );

  const renderInsuranceDetails = () => (
    <div className="mt-6">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label htmlFor="insuranceId">Insurance Id:</label>
          <InputText
            id="insuranceId"
            name="insuranceId"
            value={selectedRow.insuranceId || ''}
            onChange={handleChange}
            className="border border-gray-300 rounded-md p-2 w-full"
          />
        </div>
        <div>
          <label htmlFor="insuranceName">Insurance Name:</label>
          <InputText
            id="insuranceName"
            name="insuranceName"
            value={selectedRow.insuranceName || ''}
            onChange={handleChange}
            className="border border-gray-300 rounded-md p-2 w-full"
          />
        </div>
        <div>
          <label htmlFor="insuranceAmount">Insurance Amount:</label>
          <InputText
            id="insuranceAmount"
            name="insuranceAmount"
            value={selectedRow.insuranceAmount || ''}
            onChange={handleChange}
            className="border border-gray-300 rounded-md p-2 w-full"
          />
        </div>
        <div>
          <label htmlFor="preferredHospitalAndClinics">
            Preferred Hospital and Clinics{" "}
            <span className="text-red-500">*</span>
          </label>
          <Dropdown
            value={selectedRow?.preferredHospitalAndClinics || ""}
            options={hospitalList}
            optionLabel="hospitalLocationNames"
            placeholder="Select a Hospital"
            name="preferredHospitalAndClinics"
            id="preferredHospitalAndClinics"
            optionValue="hospitalCode"
            onChange={handleChange}
            className="border border-gray-300 rounded-md w-full"
            disabled
          />
        </div>
      </div>
    </div>
  );

  const renderServiceDetails = () => (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <label htmlFor="serviceType">
          Service Type<span className="text-red-500">*</span>
        </label>
        <Dropdown
          value={+selectedRow?.serviceType || ''}
          options={SERVICE_TYPE_DS}
          optionLabel="value"
          placeholder="Select a Procedure"
          optionValue="id"
          name="serviceType"
          id="serviceType"
          className="border border-gray-300 rounded-md w-full"
          onChange={handleChange}
        />
      </div>
      <div>
        <label htmlFor="serviceSubTypeId">
          Service Sub Type<span className="text-red-500">*</span>
        </label>
        <Dropdown
          value={+selectedRow?.serviceSubTypeId || ''}
          optionLabel="name"
          placeholder="Select Service Sub Type"
          options={SUB_SERVICE_LIST}
          name="serviceSubTypeId"
          id="serviceSubTypeId"
          optionValue="value"
          className="border border-gray-300 rounded-md w-full"
          onChange={handleChange}
        />
      </div>
      <div>
        <label htmlFor="hospitalizationTypeId">
          Hospitalization Type<span className="text-red-500">*</span>
        </label>
        <Dropdown
          options={hospitalizationOptions}
          optionLabel="name"
          placeholder="Select Hospitalization Type"
          name="hospitalizationTypeId"
          id="hospitalizationTypeId"
          value={+selectedRow?.hospitalizationTypeId || ''}
          optionValue="value"
          onChange={handleChange}
          className="border border-gray-300 rounded-md w-full"
        />
      </div>
      <div>
        <label htmlFor="procedureId">Hospitalization Sub Type</label>
        <Dropdown
          value={+selectedRow?.procedureId || ''}
          options={procedureList}
          optionLabel="hospitalizationSubType"
          placeholder="Select a Procedure"
          optionValue="hospitalizationSubTypeId"
          onChange={handleChange}
          className="border border-gray-300 rounded-md w-full"
          name="procedureId"
          id="procedureId"
        />
      </div>
      {selectedRow.procedureId && +selectedRow.procedureId > 79 && (
        <div>
          <label htmlFor="procedureNameDescription">
            Hospitalization Subtype Description
          </label>
          <InputText
            id="procedureNameDescription"
            name="procedureNameDescription"
            onChange={handleChange}
            value={selectedRow.procedureNameDescription || ''}
            className="border border-gray-300 rounded-md p-2 w-full"
          />
        </div>
      )}
      <div>
        <label htmlFor="procedurePlannedStartDate">
          Planned Start Date<span className="text-red-500">*</span>
        </label>
        <Calendar
          name="procedurePlannedStartDate"
          id="procedurePlannedStartDate"
          value={parseDate(selectedRow?.procedurePlannedStartDate)}
          onChange={handleChange}
          className="border border-gray-300 rounded-md p-2 w-full"
          dateFormat="dd/mm/yy"
          style={{ height: "40px" }}
        />
      </div>
      <div>
        <label htmlFor="procedurePlannedEndDate">
          Planned End Date<span className="text-red-500">*</span>
        </label>
        <Calendar
          name="procedurePlannedEndDate"
          onChange={handleChange}
          id="procedurePlannedEndDate"
          value={parseDate(selectedRow?.procedurePlannedEndDate)}
          className="border border-gray-300 rounded-md p-2 w-full"
          dateFormat="dd/mm/yy"
          style={{ height: "40px" }}
        />
      </div>
      <div>
        <label htmlFor="procedurePlannedDate" className="flex items-center gap-1">
          <span>Planned Confirmed Date</span>
          <span className="text-red-500">*</span>
        </label>
        <Calendar
          name="procedurePlannedDate"
          onChange={handleChange}
          id="procedurePlannedDate"
          value={parseDate(selectedRow?.procedurePlannedDate)}
          className="border border-gray-300 rounded-md p-2 w-full"
          dateFormat="dd/mm/yy"
          style={{ height: "40px" }}
        />
      </div>
      <div>
        <label htmlFor="status">Status</label>
        <Dropdown
          value={selectedRow?.status || ''}
          options={STATUS_DS}
          optionLabel="value"
          placeholder="Select a Status"
          optionValue="id"
          name="status"
          id="status"
          className="border border-gray-300 rounded-md p-2 w-full"
          onChange={handleChange}
        />
      </div>
      <div>
        <label htmlFor="estimateAmountForProcedure" style={{ fontSize: "small" }}>
          Estimate Amount for Procedure
        </label>
        <InputText
          id="estimateAmountForProcedure"
          name="estimateAmountForProcedure"
          onChange={handleChange}
          value={selectedRow.estimateAmountForProcedure || ''}
          className="border border-gray-300 rounded-md p-2 w-full"
        />
      </div>
      <div>
        <label htmlFor="hasOtherMedicalConditions">
          Do you have any other medical conditions?
        </label>
        <InputText
          id="hasOtherMedicalConditions"
          name="hasOtherMedicalConditions"
          onChange={handleChange}
          value={selectedRow.hasOtherMedicalConditions || ''}
          className="border border-gray-300 rounded-md p-2 w-full"
        />
      </div>
      {selectedRow?.status === 7 && (
        <div>
          <label htmlFor="reasonForHold">
            Reason for Hold<span className="text-red-500">*</span>
          </label>
          <InputTextarea
            id="reasonForHold"
            name="reasonForHold"
            onChange={handleChange}
            value={selectedRow.reasonForHold || ''}
            className="border border-gray-300 rounded-md p-2 w-full"
            maxLength={1000}
          />
        </div>
      )}
      {selectedRow?.status === 0 && (
        <div>
          <label htmlFor="reasonForReject">
            Reason for Reject<span className="text-red-500">*</span>
          </label>
          <InputTextarea
            id="reasonForReject"
            name="reasonForReject"
            onChange={handleChange}
            value={selectedRow.reasonForReject || ''}
            className="border border-gray-300 rounded-md p-2 w-full"
            maxLength={1000}
          />
        </div>
      )}
    </div>
  );

  const renderConsentDetails = () => (
    <div className="p-6 bg-white rounded-lg shadow-md">
      <div className="grid grid-cols-2 gap-6">
        <div>
          <label htmlFor="conciergeUserCode" className="font-medium text-gray-700">
            Concierge Executive <span className="text-red-500">*</span>
          </label>
          <Dropdown
            value={selectedRow?.conciergeUserCode || ''}
            options={ceUserList}
            optionLabel="userName"
            placeholder="Select Executive"
            optionValue="code"
            name="conciergeUserCode"
            id="conciergeUserCode"
            className="border border-gray-300 text-sm rounded-md w-full mt-2 p-2"
            onChange={handleChange}
          />
        </div>
        <div>
          <label htmlFor="conciergeStatus" className="font-medium text-gray-700">
            Concierge Status
          </label>
          <Dropdown
            value={selectedRow?.conciergeStatus || ''}
            options={CONCIERGE_STATUS_LIST}
            optionLabel="value"
            placeholder="Select a Concierge Status"
            optionValue="id"
            name="conciergeStatus"
            id="conciergeStatus"
            className="border border-gray-300 text-sm rounded-md w-full mt-2 p-2"
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="mt-6 grid grid-cols-2 gap-6">
        <div>
          <label htmlFor="bill-upload" className="flex items-center gap-2 text-[#004172] font-bold cursor-pointer">
            <FaUpload className="text-[#004172]" />
            Surgery Consent
          </label>
          <input
            id="bill-upload"
            type="file"
            accept=".pdf, image/*"
            className="hidden"
            onChange={(e) => uploadBill(e, "C")}
          />
        </div>
        {selectedRow?.conciergeStatus === 4 && (
          <div>
            <label htmlFor="summary" className="flex items-center gap-2 text-[#004172] font-bold cursor-pointer">
              <FaUpload className="text-[#004172]" />
              Discharge Summary
            </label>
            <input
              id="summary"
              type="file"
              accept=".pdf, image/*"
              className="hidden"
              onChange={(e) => uploadBill(e, "S")}
            />
          </div>
        )}
      </div>
      <div className="mt-6 border-t border-b py-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
          {consentBlob || selectedRow.surgeryConsentsName ? (
            <div className="flex items-center justify-between sm:justify-start sm:gap-3 p-3 bg-gray-50 rounded-lg">
              <span className="font-medium text-gray-700 text-sm sm:text-base whitespace-nowrap">
                Surgery Consent
              </span>
              {consentBlob ? (
                <a
                  href={consentBlob}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-shrink-0 hover:opacity-80 transition-opacity"
                >
                  <FaEye className="text-[#6fb8ef] text-lg" />
                </a>
              ) : (
                <button
                  type="button"
                  onClick={() => openUrl(selectedRow.surgeryConsentsName)}
                  className="flex-shrink-0 hover:opacity-80 transition-opacity"
                >
                  <FaEye className="text-[#6fb8ef] text-lg" />
                </button>
              )}
            </div>
          ) : null}
          {dischargeBlob || selectedRow.dischargedSummaryName ? (
            <div className="flex items-center justify-between sm:justify-start sm:gap-3 p-3 bg-gray-50 rounded-lg">
              <span className="font-medium text-gray-700 text-sm sm:text-base whitespace-nowrap">
                Discharge Summary
              </span>
              {dischargeBlob ? (
                <a
                  href={dischargeBlob}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-shrink-0 hover:opacity-80 transition-opacity"
                >
                  <FaEye className="text-[#6fb8ef] text-lg" />
                </a>
              ) : (
                <button
                  type="button"
                  onClick={() => openUrl(selectedRow.dischargedSummaryName)}
                  className="flex-shrink-0 hover:opacity-80 transition-opacity"
                >
                  <FaEye className="text-[#6fb8ef] text-lg" />
                </button>
              )}
            </div>
          ) : null}
          {selectedRow.idProofName && (
            <DocumentItem
              label="ID Proof"
              fileName={selectedRow.idProofName}
              onView={() => openUrl(selectedRow.idProofName)}
            />
          )}
          {selectedRow.idProof1Name && (
            <DocumentItem
              label="Ration Card"
              fileName={selectedRow.idProof1Name}
              onView={() => openUrl(selectedRow.idProof1Name)}
            />
          )}
          {selectedRow.insuranceCardName && (
            <DocumentItem
              label="Insurance Card"
              fileName={selectedRow.insuranceCardName}
              onView={() => openUrl(selectedRow.insuranceCardName)}
            />
          )}
          {selectedRow.medicalReportName && (
            <DocumentItem
              label="Medical Report"
              fileName={selectedRow.medicalReportName}
              onView={() => openUrl(selectedRow.medicalReportName)}
            />
          )}
        </div>
      </div>
    </div>
  );

  const renderFeedbackPopup = () => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 w-[600px] max-w-[90vw]">
        <h3 className="text-xl font-semibold mb-6">Patient Feedback Information</h3>
        <div className="space-y-6">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label htmlFor="feedback-patient-name" className="block text-sm font-medium text-gray-700 mb-2">
                Patient Name
              </label>
              <InputText
                id="feedback-patient-name"
                value={feedbackData.patientName}
                readOnly
                className="border border-gray-300 rounded-md p-3 w-full bg-gray-100 text-base"
              />
            </div>
            <div>
              <label htmlFor="feedback-patient-mobile" className="block text-sm font-medium text-gray-700 mb-2">
                Patient Mobile Number
              </label>
              <InputText
                id="feedback-patient-mobile"
                name="patientMobile"
                value={feedbackData.patientMobile}
                onChange={handleFeedbackInputChange}
                className="border border-gray-300 rounded-md p-3 w-full text-base"
              />
            </div>
          </div>
          <div className="flex justify-end gap-3 mt-8">
            <button
              onClick={() => setShowFeedbackPopup(false)}
              className="px-6 py-2.5 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 text-base font-medium"
              type="button"
            >
              Cancel
            </button>
            <button
              onClick={handleGetFeedback}
              className="px-6 py-2.5 bg-[#004172] text-white rounded-md hover:bg-[#003159] text-base font-medium"
              type="button"
            >
              Get Feedback
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  const renderConfirmPopup = () => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 w-[500px] max-w-[90vw]">
        <h3 className="text-xl font-semibold mb-4">Confirm Mobile Number Update</h3>
        <p className="text-gray-600 mb-6 text-base">
          The mobile number has been changed from {originalMobile} to {feedbackData.patientMobile}.
          Do you want to update the patient's mobile number before sending the feedback request?
        </p>
        <div className="flex justify-end gap-3">
          <button
            onClick={() => setShowConfirmPopup(false)}
            className="px-6 py-2.5 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 text-base font-medium"
            type="button"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirmUpdate}
            className="px-6 py-2.5 bg-[#004172] text-white rounded-md hover:bg-[#003159] text-base font-medium"
            type="button"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );

  const renderTabContent = () => {
    switch (activeIndex) {
      case 0:
        return renderInsuranceDetails();
      case 1:
        return renderServiceDetails();
      case 2:
        return renderConsentDetails();
      default:
        return null;
    }
  };

  return (
    <>
      <Backdrop open={loading} sx={{ color: "#FFFFFF", zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <CircularProgress size={80} color="inherit" />
      </Backdrop>

      {showFeedbackPopup && renderFeedbackPopup()}
      {showConfirmPopup && renderConfirmPopup()}

      <div>
        <div className="card">
          <div className="border border-gray-300 rounded-md p-4 mb-4">
            <h2 className="text-lg font-semibold mb-4 border-b pb-2">Personal Details</h2>
            <div className="flex flex-wrap gap-x-6">
              {personalDetails.map(renderPersonalDetailItem)}
            </div>
          </div>

          <Tabs value={activeIndex} onChange={handleTabChange}>
            <Tab label={<span style={{ fontWeight: "bold" }}>Insurance Details</span>} />
            <Tab label={<span style={{ fontWeight: "bold" }}>Service Details</span>} />
            <Tab label={<span style={{ fontWeight: "bold" }}>Consent Details</span>} />
          </Tabs>

          <div style={{
            opacity: isFormDisabled ? 0.7 : 1,
            pointerEvents: isFormDisabled ? "none" : "auto",
          }}>
            {renderTabContent()}
          </div>
        </div>

        <div className="flex justify-between">
          {selected?.traumaStatus !== undefined && (
            <div className="grid grid-cols-3 gap-4 mt-16">
              {renderTraumaStatus(selected)}
            </div>
          )}
          {(selectedRow.status === 6 || selectedRow.status === 12) && (
            <button
              className="h-12 bg-[#004172] text-white rounded-md w-36 mt-16"
              onClick={openFeeback}
              type="button"
              disabled={selectedRow.status !== 6 && selectedRow.status !== 12}
            >
              Get Feedback
            </button>
          )}
        </div>

        <div style={{ opacity: isFormDisabled ? 0.7 : 1, pointerEvents: isFormDisabled ? "none" : "auto" }}>
          <div className="mt-6">
            <div className="flex justify-between mt-10">
              {activeIndex === 2 && (
                <button
                  disabled={
                    selectedRow.billingStatus === 2 ||
                    [0, 4, 5, 6, 7].includes(selectedRow.status)
                  }
                  style={{
                    opacity: selectedRow.billingStatus === 2 ||
                      [0, 4, 5, 6, 7].includes(selectedRow.status) ? 0.5 : 1
                  }}
                  className="h-13 bg-[#004172] text-white rounded-md w-[250px]"
                  onClick={getApproval}
                  type="button"
                >
                  Get Approval from Hospital Admin
                </button>
              )}
              <div className="flex gap-4 justify-items-center">
                <button
                  className="h-9 border border-[#004172] text-[#004172] font-bold font-monospace rounded-md w-[120px]"
                  onClick={handleCancel}
                  type="button"
                >
                  Cancel
                </button>
                <button
                  className="h-9 bg-[#004172] text-white rounded-md w-[120px]"
                  onClick={updateEnqList}
                  type="button"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

AddEnquiry.propTypes = {
  selected: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    billingStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    traumaStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    traumaReason: PropTypes.string,
    patientDetails: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      salutation: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      dob: PropTypes.string,
      email: PropTypes.string,
      mobile: PropTypes.string
    })
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AddEnquiry;